import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { updateBusinessMonitoringInfo } from "../UpdateMonitoringInfo";
import { stateList } from "../../../../util/CommonLists";
import { useDispatch, useSelector } from "react-redux";
import { getFlowByName } from "../../../../config/FlowName";
import * as NextStepFlowAction from "../../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../../store";
import i18nService from "../../../../util/Internationalization/i18n/i18n";
import { PATTERNS } from "../../../../util/patterns";
import { useTranslation } from "react-i18next";

interface IProps {
    refreshDataCallback(): void;
    setFormStatus: any;
    formData: any;
    personalInfo: any;
}

const MonitoringBusinessAddressInfoForm = ({ refreshDataCallback, setFormStatus, formData, personalInfo }: IProps) => {
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, errors } = useForm({
        mode: "onBlur",
    });
    const dispatch = useDispatch();
    const monitoringInfoFlow = useSelector((state: ApplicationState) => getFlowByName(state, "ADD-YOUR-ADDITIONAL-INFORMATION"));
    const businessdMonitoringInfoFlow = useSelector((state: ApplicationState) => getFlowByName(state, "ADD-YOUR-ADDITIONAL-BUSINESS-INFORMATION"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const { t: tLang } = useTranslation();

    const onSubmit = (data: any) => {
        setLoading(true);
        data.country = "";
        updateBusinessMonitoringInfo(personalInfo, data).then((data: any) => {
            if (monitoringInfoFlow && monitoringInfoFlow.flowStepStatus !== "COMPLETED") {
                completeGetStartedItem(monitoringInfoFlow.flowStepId, monitoringInfoFlow.flowName ? monitoringInfoFlow.flowName : " ");
            }
            if (businessdMonitoringInfoFlow && businessdMonitoringInfoFlow.flowStepStatus !== "COMPLETED") {
                completeGetStartedItem(businessdMonitoringInfoFlow.flowStepId, businessdMonitoringInfoFlow.flowName ? businessdMonitoringInfoFlow.flowName : " ");
            }
            refreshDataCallback();
            setLoading(false);

            setFormStatus(false);
        });
    };

    return (
        <div id="monitored-info-address-form" className={`${loading && "loading"}`}>
            <form onSubmit={handleSubmit(onSubmit)} id="monitored-info-address-form-container">
                <fieldset className="form-row no-margin inline">
                    <div className="row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <legend className="legend-label">  <label htmlFor="label-address-line-1">
                                {tLang("identityVault.monitoredInformation.businessAddressWidget.label.street")} <span className="required" title="Mandatory">*</span>
                           </label> </legend>
                        </div>

                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <div className={`form-row row ${errors["address1"] && "status-error"}`}>
                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                    <label htmlFor="label-address-line1">
                                        Address Line 1{" "}
                                        <span className="required" title="Mandatory">
                                            *
                                        </span>
                                    </label>
                                </div>
                                <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                    <input
                                        aria-required="true"
                                        type="text"
                                        defaultValue={formData.address1}
                                        required
                                        name="address1"
                                        className="inputbox"
                                        id="label-address-line-1"
                                        ref={register({ required: true, pattern: PATTERNS.STREETADDRESS.pattern })}
                                        placeholder={tLang("identityVault.monitoredInformation.businessAddressWidget.placeholder.addressLine1")}
                                    />
                                    {errors["address1"] && errors["address1"].type === "required" && (
                                        <span className="form-error">
                                            {tLang("identityVault.monitoredInformation.businessAddressWidget.validationMessage.address1.required")}
                                        </span>
                                    )}
                                    {errors["address1"] && errors["address1"].type === "pattern" && (
                                        <span className="form-error">
                                            {tLang("identityVault.monitoredInformation.businessAddressWidget.validationMessage.address1.pattern")}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className={`form-row row ${errors["address2"] && "status-error"}`}>
                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                    <label htmlFor="label-address-line-2">Address Line 2</label>
                                </div>
                                <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                    <input
                                        aria-required="true"
                                        type="text"
                                        defaultValue={formData.address2}
                                        name="address2"
                                        className="inputbox"
                                        id="label-address-line-2"
                                        ref={register({ pattern: PATTERNS.STREETADDRESS.pattern })}
                                        placeholder={tLang("identityVault.monitoredInformation.businessAddressWidget.placeholder.addressLine2")}
                                    />
                                    {errors["address2"] && errors["address2"].type === "pattern" && (
                                        <span className="form-error">
                                            {tLang("identityVault.monitoredInformation.businessAddressWidget.validationMessage.address2.pattern")}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <div className={`form-row inline row ${errors["city"] && "status-error"}`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="label-address-city">
                            {tLang("identityVault.monitoredInformation.businessAddressWidget.label.city")}{" "}
                            <span className="required" title="Mandatory">
                                *
                            </span>
                        </label>
                    </div>
                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <input
                            aria-required="true"
                            type="text"
                            name="city"
                            defaultValue={formData.city}
                            className="inputbox"
                            id="label-address-city"
                            required
                            ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                            placeholder={tLang("identityVault.monitoredInformation.businessAddressWidget.placeholder.city")}
                        />
                        {errors["city"] && errors["city"].type === "required" && (
                            <span className="form-error">{tLang("identityVault.monitoredInformation.businessAddressWidget.validationMessage.city.required")}</span>
                        )}
                        {errors["city"] && errors["city"].type === "pattern" && (
                            <span className="form-error">{tLang("identityVault.monitoredInformation.businessAddressWidget.validationMessage.city.pattern")}</span>
                        )}
                    </div>
                </div>

                <div className={errors["state"] ? "form-row inline row status-error" : "form-row inline row"}>
                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="label-address-state">
                                {tLang("identityVault.monitoredInformation.businessAddressWidget.label.state")}{" "}
                                <span className="required" title="Mandatory">
                                    *
                                </span>
                            </label>
                        </div>
                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <select
                                aria-required="true"
                                className="inputbox"
                                id="label-address-state"
                                defaultValue={formData.state}
                                name="state"
                                ref={register({ required: true, validate: (value) => value !== "---" })}
                            >
                                {stateList.map((val: any) => (
                                    <option key={val.name} value={val.value}>
                                        {val.name}
                                    </option>
                                ))}
                            </select>
                            {errors["state"] && errors["state"].type === "validate" && (
                                <span className="form-error">
                                    {tLang("identityVault.monitoredInformation.businessAddressWidget.validationMessage.state.required")}
                                </span>
                            )}
                        </div>
                    </div>
                </div>

                <div className={`form-row inline row ${errors["zipcode"] && "status-error"}`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="label-address-zipcode">
                            {tLang(
                                `identityVault.monitoredInformation.businessAddressWidget.label.${
                                    i18nService.get("ZipCode.Label") === "Zip Code" ? "zipcode" : "postalCode"
                                }`
                            )}
                            <span className="required" title="Mandatory">
                                *
                            </span>
                        </label>
                    </div>
                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <input
                            aria-required="true"
                            type="text"
                            className="inputbox"
                            id="label-address-zipcode"
                            defaultValue={formData.zipcode}
                            name="zipcode"
                            required
                            ref={register({
                                required: true,
                                pattern: PATTERNS[i18nService.get("ZipCode.Pattern")].pattern,
                                maxLength: i18nService.get("ZipCode.MaxLength"),
                            })}
                            placeholder={tLang(
                                `identityVault.monitoredInformation.businessAddressWidget.placeholder.${
                                    i18nService.get("ZipCode.Label") === "Zip Code" ? "zipcode" : "postalCode"
                                }`
                            )}
                        />
                        {errors["zipcode"] && errors["zipcode"].type === "required" && (
                            <span className="form-error">
                                {tLang(
                                    `identityVault.monitoredInformation.businessAddressWidget.validationMessage.${
                                        i18nService.get("ZipCode.Label") === "Zip Code" ? "zipcode" : "postalCode"
                                    }.required`
                                )}
                            </span>
                        )}
                        {errors["zipcode"] && errors["zipcode"].type === "pattern" && (
                            <span className="form-error">
                                {tLang(
                                    `identityVault.monitoredInformation.businessAddressWidget.validationMessage.${
                                        i18nService.get("ZipCode.Label") === "Zip Code" ? "zipcode" : "postalCode"
                                    }.pattern`
                                )}
                            </span>
                        )}
                        {errors["zipcode"] && errors["zipcode"].type === "maxLength" && (
                            <span className="form-error">
                                {tLang(
                                    `identityVault.monitoredInformation.businessAddressWidget.validationMessage.${
                                        i18nService.get("ZipCode.Label") === "Zip Code" ? "zipcode" : "postalCode"
                                    }.maxLength`
                                )}
                            </span>
                        )}
                    </div>
                </div>

                <div className="margin-vertical-l"></div>

                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-inline list-reset">
                            <li>
                                <button
                                    type="button"
                                    className="btn-default btn-link btn-no-padding btn-no-border btn-min-width"
                                    onClick={() => {
                                        setFormStatus(false);
                                        window.addToDataLayer({ event: "Cancel Editing Address" });
                                    }}
                                >
                                    <span className="btn-text">{tLang("identityVault.monitoredInformation.businessAddressWidget.cancelButtonText")}</span>
                                </button>
                            </li>
                            <li className="margin-left-s">
                                <button
                                    type="submit"
                                    className="btn-default btn-primary btn-min-width"
                                    disabled={!(Object.keys(errors).length === 0)}
                                    onClick={() => window.addToDataLayer({ event: "Save Edited Address" })}
                                >
                                    <span className="btn-text">{tLang("identityVault.monitoredInformation.businessAddressWidget.saveButtonText")}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default MonitoringBusinessAddressInfoForm;
